/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AdminGetViewupSnsAccountsReqQueryDto
 */
export interface AdminGetViewupSnsAccountsReqQueryDto {
    /**
     * 관리자 설정 성별
     * @type {string}
     * @memberof AdminGetViewupSnsAccountsReqQueryDto
     */
    'gender'?: AdminGetViewupSnsAccountsReqQueryDtoGenderEnum;
    /**
     * 관리자 설정 나이
     * @type {number}
     * @memberof AdminGetViewupSnsAccountsReqQueryDto
     */
    'age'?: number;
    /**
     * 현재 페이지
     * @type {number}
     * @memberof AdminGetViewupSnsAccountsReqQueryDto
     */
    'page'?: number;
    /**
     * 한 페이지에 보여줄 데이터 수
     * @type {number}
     * @memberof AdminGetViewupSnsAccountsReqQueryDto
     */
    'limit'?: number;
    /**
     * 정렬 기준
     * @type {string}
     * @memberof AdminGetViewupSnsAccountsReqQueryDto
     */
    'sort'?: AdminGetViewupSnsAccountsReqQueryDtoSortEnum;
    /**
     * 계정 상태
     * @type {string}
     * @memberof AdminGetViewupSnsAccountsReqQueryDto
     */
    'status'?: AdminGetViewupSnsAccountsReqQueryDtoStatusEnum;
    /**
     * 검색 타입
     * @type {string}
     * @memberof AdminGetViewupSnsAccountsReqQueryDto
     */
    'searchType'?: AdminGetViewupSnsAccountsReqQueryDtoSearchTypeEnum;
    /**
     * 검색어
     * @type {string}
     * @memberof AdminGetViewupSnsAccountsReqQueryDto
     */
    'keyword'?: string;
    /**
     * 시작일
     * @type {string}
     * @memberof AdminGetViewupSnsAccountsReqQueryDto
     */
    'startDate'?: string;
    /**
     * 종료일
     * @type {string}
     * @memberof AdminGetViewupSnsAccountsReqQueryDto
     */
    'endDate'?: string;
    /**
     * 플랫폼 카테고리 id 목록
     * @type {Array<number>}
     * @memberof AdminGetViewupSnsAccountsReqQueryDto
     */
    'platformCategoryIds'?: Array<number>;
    /**
     * 삭제된 계정 포함 여부
     * @type {boolean}
     * @memberof AdminGetViewupSnsAccountsReqQueryDto
     */
    'isDeleted'?: boolean;
    /**
     * 알바원 연결 여부
     * @type {boolean}
     * @memberof AdminGetViewupSnsAccountsReqQueryDto
     */
    'isAlbaone'?: boolean;
    /**
     * 알바원 피드 에러여부
     * @type {boolean}
     * @memberof AdminGetViewupSnsAccountsReqQueryDto
     */
    'isAlbaoneFeedError'?: boolean;
}

export const AdminGetViewupSnsAccountsReqQueryDtoGenderEnum = {
    M: 'M',
    F: 'F',
    Unknown: 'unknown'
} as const;

export type AdminGetViewupSnsAccountsReqQueryDtoGenderEnum = typeof AdminGetViewupSnsAccountsReqQueryDtoGenderEnum[keyof typeof AdminGetViewupSnsAccountsReqQueryDtoGenderEnum];
export const AdminGetViewupSnsAccountsReqQueryDtoSortEnum = {
    Latest: 'latest',
    Oldest: 'oldest'
} as const;

export type AdminGetViewupSnsAccountsReqQueryDtoSortEnum = typeof AdminGetViewupSnsAccountsReqQueryDtoSortEnum[keyof typeof AdminGetViewupSnsAccountsReqQueryDtoSortEnum];
export const AdminGetViewupSnsAccountsReqQueryDtoStatusEnum = {
    All: 'all',
    Waiting: 'waiting',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type AdminGetViewupSnsAccountsReqQueryDtoStatusEnum = typeof AdminGetViewupSnsAccountsReqQueryDtoStatusEnum[keyof typeof AdminGetViewupSnsAccountsReqQueryDtoStatusEnum];
export const AdminGetViewupSnsAccountsReqQueryDtoSearchTypeEnum = {
    Id: 'id',
    SnsId: 'snsId'
} as const;

export type AdminGetViewupSnsAccountsReqQueryDtoSearchTypeEnum = typeof AdminGetViewupSnsAccountsReqQueryDtoSearchTypeEnum[keyof typeof AdminGetViewupSnsAccountsReqQueryDtoSearchTypeEnum];


